export type AbortControllerType = typeof AbortController;
export type RequestHeaders = Record<string, string>;
export type QueryParams = Record<string, any>;

/** REST API abstraction */
export interface ApiClient {
    get(path: string, params?: QueryParams, headers?: RequestHeaders): Promise<any>;
    post(path: string, body: any, headers?: RequestHeaders): Promise<any>;
    put(path: string, body: any, headers?: RequestHeaders): Promise<any>;
    delete(path: string, params?: QueryParams, headers?: RequestHeaders): Promise<any>;
    abort(): void | typeof undefined;
    setRequestHeader(key: string, val: string | null): void;
}

export const COMMON_HEADERS = {
    "Cache-Control": "no-cache",
    "X-Server-Select": "frontend",
};
